import AppBarh from "../components/AppBarh";
import Footer from "../components/Footer";
import { Box, Typography } from "@mui/material";
import * as React from "react";

const Terms = () => {

 const wrapper: React.CSSProperties = {
    maxWidth: "900px",
    margin: "40px auto",
    padding: "30px",
    backgroundColor: "#ffffff",
    border: "1px solid #ddd",
    borderRadius: "10px",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    color: "#333",
  };

  const title: React.CSSProperties = {
    fontSize: "22px",
    fontWeight: "bold",
    textAlign: "center",
    marginBottom: "30px",
    color: "#1a202c",
  };

  const heading: React.CSSProperties = {
    fontSize: "16px",
    fontWeight: 600,
    marginTop: "30px",
    marginBottom: "10px",
    color: "#2d3748",
  };

  const paragraph: React.CSSProperties = {
    fontSize: "14px",
    lineHeight: "1.7",
    marginBottom: "20px",
    textAlign: "justify",
  };

  const list: React.CSSProperties = {
    paddingLeft: "20px",
    fontSize: "14px",
    marginBottom: "20px",
  };

  const listItem: React.CSSProperties = {
    marginBottom: "8px",
  };

  const email: React.CSSProperties = {
    color: "#0073e6",
    textDecoration: "none",
  };

  return (

    <div className="Example">
      <AppBarh/>

        <div style={wrapper}>
           <h1 style={title}>Terms & Conditions</h1>

           <p style={paragraph}>
             These Terms & Conditions govern your use of the services and participation in the activities offered by the Uva Wellassa University Alumni Association.
           </p>

           <h2 style={heading}>Membership:</h2>
           <ul style={list}>
                   <li style={listItem}>Membership is open to all graduates of Uva Wellassa University.</li>
                   <li style={listItem}>Members are expected to uphold the values and objectives of the Association.</li>
           </ul>

           <h2 style={heading}>Use of Services:</h2>

           <ul style={list}>
             <li style={listItem}>Members and users agree to use the alumni association website, services, and platforms responsibly.</li>
             <li style={listItem}>Misuse of the association’s resources or engagement in activities that go against its mission may result in termination of membership.</li>
           </ul>

           <h2 style={heading}>Events and Activities:</h2>

           <ul style={list}>
             <li style={listItem}>Participation in events is subject to availability and may require registration or fees.</li>
             <li style={listItem}>The Association reserves the right to reschedule or cancel events when necessary.</li>
           </ul>

           <h2 style={heading}>Intellectual Property:</h2>

           <p style={paragraph}>
                    All content published by the Association (e.g., articles, photos, videos) remains its intellectual property and should not be used without permission.
           </p>

           <h2 style={heading}>Limitation of Liability:</h2>

           <p style={paragraph}>
                   Uva Wellassa University Alumni Association shall not be held liable for any direct or indirect damages arising from participation in its activities, unless resulting from gross negligence.
           </p>

           <h2 style={heading}>Amendments:</h2>

           <p style={paragraph}>
              These terms may be updated from time to time. Continued use of services implies acceptance of any such changes.
              For questions or clarifications, please contact us at {" "}
              <a href="mailto:alumni@std.uwu.ac.lk" style={email}> alumni@std.uwu.ac.lk </a>{" "}
           </p>

         </div>

      <Footer/>
    </div>

  );
};

export default Terms;